import React, { useState, lazy } from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon, SparklesIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const CHECKOUT_URL = 'https://dominandoshopify.impultienda.ar/';
const UPSELL_CHECKOUT_URL = 'https://dominandoshopify.impultienda.ar/';
export function PricingSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const included = ['Acceso de por vida al programa', 'Acceso a todos los BONOS', '+30 videos prácticos paso a paso', 'Acceso a la comunidad de alumnos', 'Plantillas prácticas para aplicar', 'Garantía de 14 días'];
  const currentCheckout = UPSELL_CHECKOUT_URL;
  return <section id="compra" className="bg-gradient-to-b from-gray-900 to-black text-white py-8 md:py-12 px-4 bg-[#090202] mt-[0px] mb-[0px] pt-[60px] pb-[60px]" data-id="element-208" data-mp="225qjryvtn83x">
      <div className="max-w-3xl mx-auto" data-id="element-209" data-mp="7ulb2g5vo5hq">
        {/* Header */}
        <div className="rounded-t-2xl px-6 py-8 text-center bg-[#16A34A] mt-[-20px] mb-[-20px]" data-id="element-210" data-mp="1mh6kkza8f25g">
          <h2 className="text-2xl md:text-3xl font-black uppercase leading-tight mb-3" data-id="element-211" data-mp="1hpg2u88ytc40">
            Accede ahora y empieza a{' '}
            <span className="underline decoration-4 decoration-yellow-300" data-id="element-212" data-mp="1crn0jqas9290">
              vender este fin de semana
            </span>
          </h2>
          <p className="text-base md:text-lg text-green-100 max-w-xl mx-auto" data-id="element-213" data-mp="25fireedo7zxv">
            Estás a un producto de cambiar tu vida.
          </p>
        </div>

        {/* Main Card */}
        <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-b-3xl p-6 md:p-10 shadow-2xl border-2 border-t-0 border-slate-600 bg-[#444040]" data-id="element-214" data-mp="20emrsd0cqzy9">
          {/* Product Title & Includes */}
          <div className="text-center mb-6" data-id="element-215" data-mp="1ri3xoxgdx603">
            <h3 className="text-3xl md:text-4xl font-black text-slate-200 mb-2 tracking-wide" data-id="element-216" data-mp="k38zf1oedpt8">
              DOMINANDO SHOPIFY💰
            </h3>
            <p className="text-xl text-white mb-6 font-[500]" data-id="element-217" data-mp="g2yvrvo2vbhj">Resumen</p>

            <div className="text-left max-w-md mx-auto space-y-3 mb-8" data-id="element-218" data-mp="hiazhi29xzlv">
              {included.map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-219" data-mp="merxd3z9zsc5" data-mpi={index}>
                  <span className="w-3 h-3 bg-green-500 rounded-full flex-shrink-0" data-id="element-220" data-mp="7j2a72ict95u"></span>
                  <span className="text-base md:text-lg text-slate-200 font-medium" data-id="element-221" data-mp="chdj9b0trfn0">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Selection Instruction */}
          <div className="text-center mb-6" data-id="element-222" data-mp="3kyi4brwfe2w8">
            <p className="text-base text-slate-300" data-id="element-223" data-mp="3kzjfrxhcsreh">
              👇 Revisa la oferta y haz clic en el botón para comenzar:
            </p>
          </div>

          {/* Plan Options */}
          <div className="space-y-4 mb-8" data-id="element-224" data-mp="3bxjyr56c9nbj">
            {/* Oferta completa - USD 37 */}
            <div className="relative rounded-2xl p-5 md:p-6 border-2 border-green-400 bg-slate-700/80 shadow-[0_0_20px_rgba(34,197,94,0.2)]" data-id="element-225" data-mp="3fzx25mxm5955">
              {/* Badge */}
              <div className="absolute -top-3 left-4" data-id="element-226" data-mp="2xcxxgane89ky">
                <span className="inline-flex items-center gap-1.5 bg-green-500 text-white text-xs font-black uppercase tracking-wider px-4 py-1.5 rounded-full shadow-lg" data-id="element-227" data-mp="2sdble4jawzdq">
                  Acceso Completo ⭐⭐⭐⭐⭐
                </span>
              </div>

              <div className="flex items-center justify-between mt-2" data-id="element-228" data-mp="3g9pfyhv42kny">
                <div data-id="element-229" data-mp="3g7utv083smia">
                  <p className="text-lg font-bold text-white mb-1" data-id="element-230" data-mp="3baw0ijw9kjl5">
                    Programa + 5 BONOS + Consultoría grupal ⭐
                  </p>
                  <p className="text-sm text-red-400 font-bold line-through mb-1" data-id="element-231" data-mp="3p1rdo8dspmuj">
                    Antes USD 83
                  </p>
                  <p className="text-3xl md:text-4xl font-black text-green-400" data-id="element-232" data-mp="3l31u1y25z92g">
                    USD 37
                  </p>
                  <p className="text-sm text-green-300 font-semibold mt-1" data-id="element-233" data-mp="3u25b6whrteeb">
                    Incluye 4 consultorías grupales en vivo
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center" data-id="element-234" data-mp="lxl55q66i40z">
            <motion.div animate={{
            scale: [1, 1.03, 1]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-235" data-mp="qpw8l304o7ya">
              <CTAButton text="ACCEDE AHORA - 14 DÍAS DE GARANTÍA⭐" href={currentCheckout} size="large" className="!bg-green-500 hover:!bg-green-400 !text-white font-black text-lg md:text-xl w-full shadow-[0_0_30px_rgba(34,197,94,0.4)] hover:shadow-[0_0_40px_rgba(34,197,94,0.6)]" data-id="element-236" data-mp="3v6p4puwc28q8" />
            </motion.div>

            <div className="mt-4 inline-block bg-green-500/10 px-4 py-1.5 rounded-full border border-green-500/30 animate-pulse" data-id="element-237" data-mp="1jetpp2slrypg">
              <p className="text-sm md:text-base text-green-400 font-black tracking-wide" style={{
              textAlign: "center",
              paddingLeft: "19px",
              paddingRight: "20px",
              width: "228px",
              height: "37px"
            }} data-id="element-238" data-mp="38w7as6ys7euw">
                💳 PAGARAS EN LA MONEDA DE TU PAIS
              </p>
            </div>

            <div className="mt-4 flex flex-col items-center gap-3" data-id="element-239" data-mp="2z41a88ugrp43">
              <p className="text-sm text-slate-400 font-semibold" data-id="element-240" data-mp="2u6rop4a73xlj">
                🔒 Pago internacional seguro y protegido
              </p>
            </div>
          </div>
        </div>

        <div className="bg-blue-900 bg-opacity-50 border-2 border-blue-400 rounded-2xl p-8 text-center pt-[20px] pb-[20px] mt-[25px] mb-[25px]" data-id="element-241" data-mp="2l5tjiio0tk1d">
          <img src="https://cdn.magicpatterns.com/uploads/hAWuxWW2eK7WfVFHUcXnak/guarantee-14-days-en.png" alt="Garantía de satisfacción por 14 días" loading="lazy" className="w-32 h-32 md:w-40 md:h-40 object-contain mx-auto mb-4" data-id="element-242" data-mp="2g9csngpfsrkl" />
          <h4 className="text-2xl font-bold mb-4" data-id="element-243" data-mp="9f92f9r21njs">
            ✓ Garantía de 14 días sin complicaciones
          </h4>
          <p className="text-lg text-gray-300" data-id="element-244" data-mp="28nquaqcr9i8z">
            Queremos que ingreses con tranquilidad. Si accedes al programa y
            sientes que no es para ti, puedes solicitar la devolución. Sin
            preguntas ni complicaciones.
          </p>
        </div>

        {/* WhatsApp Dudas */}
        <div className="mt-8 text-center" data-id="element-245" data-mp="2mo1mpxtpr4w9">
          <h4 className="text-xl md:text-2xl font-bold text-white mb-4" data-id="element-246" data-mp="2mp392yg6jdta">
            ¿Tienes dudas? Haz clic aquí abajo.
          </h4>
          <a href="https://api.whatsapp.com/send/?phone=5491167000518&text=Hola%2C+mi+nombre+es+........+y+quiero+ingresar+al+programa+DOMINANDO+SHOPIFY+y+activar+mi+m%C3%A1quina+de+ventas+100%25+en+autom%C3%A1tico+hoy+mismo.+Quiero+saber+c%C3%B3mo......&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#20bd5a] text-white font-bold text-lg md:text-xl px-8 py-4 rounded-full transition-all duration-200 hover:scale-105 shadow-[0_0_20px_rgba(37,211,102,0.4)]" data-id="element-247" data-mp="2rkik7imsyvm0">
            <svg viewBox="0 0 24 24" className="w-7 h-7 fill-current" xmlns="http://www.w3.org/2000/svg" data-id="element-248" data-mp="18o6t2r0go1b7">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-249" data-mp="13pnbf2swhbon" />
            </svg>
            Escríbenos por WhatsApp
          </a>
        </div>

        {/* ¿Cuánto cuesta NO tenerlo? */}
        <div className="mt-10 rounded-2xl border-2 border-purple-500/50 overflow-hidden bg-[#0A0D16]" data-id="element-250" data-mp="3vk5lml875n24">
          <div className="text-center py-8 px-4" data-id="element-251" data-mp="4ew47hy9qh44">
            <h3 className="text-2xl md:text-4xl font-black text-white uppercase" data-id="element-252" data-mp="4ggw0zt77lya">
              ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
            </h3>
          </div>

          {/* Table */}
          <div className="mx-4 mb-6 rounded-xl overflow-hidden border border-purple-500/30" data-id="element-253" data-mp="dfls7zhaf37a">
            {/* Header */}
            <div className="grid grid-cols-2" data-id="element-254" data-mp="1xv0em72o8am4">
              <div className="bg-[#1a1a2e] px-4 py-4 md:px-6 md:py-5 border-r border-purple-500/30" data-id="element-255" data-mp="1sxqqcur0q4zv">
                <p className="text-white font-bold text-sm md:text-lg text-center" data-id="element-256" data-mp="1ovn6bhqa9s2z">
                  Sin Dominando Shopify
                </p>
              </div>
              <div className="bg-[#1a1a2e] px-4 py-4 md:px-6 md:py-5" data-id="element-257" data-mp="2gnl37cbc7tk4">
                <p className="text-[#FC9DFF] font-bold text-sm md:text-lg text-center" data-id="element-258" data-mp="2gmt59uu9pjqo">
                  Costo real
                </p>
              </div>
            </div>

            {/* Rows */}
            {[{
            sin: 'Meses buscando info gratis en YouTube',
            costo: '+200 horas perdidas sin resultados'
          }, {
            sin: 'Probar sin método ni estrategia',
            costo: 'Dinero tirado en publicidad sin retorno'
          }, {
            sin: 'No saber elegir un nicho rentable',
            costo: 'Productos que nadie compra — frustración'
          }, {
            sin: 'Crear tu tienda sin guía profesional',
            costo: 'Tienda que no convierte — USD 0 en ventas'
          }, {
            sin: 'Sin acompañamiento ni soporte',
            costo: 'Te bloqueas y abandonas — vuelves al punto de partida'
          }, {
            sin: 'Miedo a invertir en publicidad',
            costo: 'Sigues en el mismo trabajo que no te satisface'
          }, {
            sin: 'Esperar "el momento perfecto"',
            costo: 'El mismo ciclo — el próximo año igual'
          }].map((row, index) => <div key={index} className={`grid grid-cols-2 ${index % 2 === 0 ? 'bg-[#12121f]' : 'bg-[#0e0e1a]'}`} data-id="element-259" data-mp="26jvx4tgzdugz" data-mpi={index}>
                <div className="px-4 py-4 md:px-6 md:py-5 border-r border-purple-500/20" data-id="element-260" data-mp="2l7csm78qs7e6">
                  <p className="text-gray-300 text-xs md:text-base" data-id="element-261" data-mp="2l5jnwxhovx8t">
                    {row.sin}
                  </p>
                </div>
                <div className="px-4 py-4 md:px-6 md:py-5" data-id="element-262" data-mp="2c7g2e16pf0h0">
                  <p className="text-white font-bold text-xs md:text-base" data-id="element-263" data-mp="2g89n6lounz5o">
                    {row.costo}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        {/* Mental Triggers */}
        <div className="grid md:grid-cols-2 gap-6 mt-8" data-id="element-264" data-mp="278mucoa6s1o8">
          <div className="rounded-xl p-6 border border-gray-800 flex items-start gap-4 bg-[#0A0D16]" data-id="element-265" data-mp="1sip5s78ch9yi">
            <div className="bg-green-500/20 p-3 rounded-lg text-green-500 shrink-0" data-id="element-266" data-mp="1xhiihxft4wxm">
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-267" data-mp="1xffgef1drdcj">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-268" data-mp="1ogajte9dpu30" />
              </svg>
            </div>
            <div data-id="element-269" data-mp="3cg61gkbg41yl">
              <h3 className="text-white font-bold text-lg mb-2" data-id="element-270" data-mp="3cgpebmm8o05r">
                Potencial de retorno
              </h3>
              <p className="text-gray-400" data-id="element-271" data-mp="80myq4b5el6y">
                Puedes recuperar la inversión con tus primeras ventas y cuentas
                con una garantía de 14 días.
              </p>
            </div>
          </div>

          <div className="bg-gray-900/50 rounded-xl p-6 border border-gray-800 flex items-start gap-4" data-id="element-272" data-mp="3v5vryv86e1kp">
            <div className="bg-yellow-500/20 p-3 rounded-lg text-yellow-500 shrink-0" data-id="element-273" data-mp="2optjegmhkoua">
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-274" data-mp="2jqguzrfyv9pl">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-275" data-mp="z6bqijfafpja" />
              </svg>
            </div>
            <div data-id="element-276" data-mp="1czt9o342b08s">
              <h3 className="text-white font-bold text-lg mb-2" data-id="element-277" data-mp="1d0cubrl3k2qi">
                Acción Rápida
              </h3>
              <p className="text-gray-400" data-id="element-278" data-mp="1hy4icaimf4pf">
                Los BONUS y el valor especial están por terminar!!
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mt-8" data-id="element-279" data-mp="1rxvfkjykfxt7">
          <CTAButton text="QUIERO ASEGURAR MI LUGAR AHORA 👉🏻" onClick={scrollToCompra} size="large" className="!bg-red-600 hover:!bg-red-500 !text-white shadow-[0_0_30px_rgba(220,38,38,0.5)] hover:shadow-[0_0_50px_rgba(220,38,38,0.7)] w-full md:w-auto" data-id="element-280" data-mp="1rupt7chbna16" />
          <p className="text-gray-400 mt-4 text-sm font-medium" data-id="element-281" data-mp="32flt9pssoh0j">
            🔒 Pago 100% seguro y garantizado
          </p>
        </div>
      </div>
    </section>;
}